import React, { useEffect, useRef, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { setRecoil } from "recoil-nexus";
import styled from "styled-components";
import {
  AdvertisementType,
  EventType,
} from "../../../controller/MasterController";
import { qrAuthState } from "../../../recoil/auth";
import { eventState } from "../../../recoil/event";
import { langState, langText } from "../../../recoil/lang";
import CustomSection, {
  customUserIdList,
  getCustomListByUserId,
} from "./customContent/customSection";

const EventContent = ({
  adverEventList,
  adverStoreList,
  navigateAdStore,
  adverClick,
  resetPage,
  eventView,
  setEventView,
}: {
  adverEventList: any;
  adverStoreList: AdvertisementType[];
  navigateAdStore: (storeId: number) => void;
  adverClick: (storeId: number, storeName: string) => void;
  resetPage: any;
  eventView: boolean;
  setEventView: any;
}) => {
  const auth = useRecoilValue(qrAuthState);
  const [lang, setLang] = useRecoilState<number>(langState);

  const [slideIndex, setSlideIndex] = useState(0);
  const [eventViewTrueCount, setEventViewTrueCount] = useState<number>(0);
  const sliderRef = useRef<any>(null);

  // 딜라이트 인기메뉴 BEST5
  let customAddLength = getCustomListByUserId(auth.user_id);

  // 룰렛이벤트 바로가기
  const handleGoRouletteEvent = () => {
    if (sliderRef.current) {
      setEventView(true);
      setEventViewTrueCount(1);
      setSlideIndex(0);
      sliderRef.current.style.transform = `translateX(-${slideIndex * 100}%)`;
    }
  };
  const slideHandler = (direction: number) => {
    if (eventView && adverEventList) {
      setEventViewTrueCount(1);
    } else {
      setEventViewTrueCount(0);
    }
    setSlideIndex((prev) => {
      let nextIndex = prev + direction;
      if (nextIndex < 0) {
        nextIndex =
          eventViewTrueCount + adverStoreList.length + customAddLength - 1;
      } else if (
        nextIndex >=
        eventViewTrueCount + adverStoreList.length + customAddLength
      ) {
        nextIndex = 0;
      }
      return nextIndex;
    });
  };

  const closeModal = () => {
    resetPage();
  };

  const eventTime = () => {
    let time = 3000;
    if (eventView === false) {
      time = 3000;
    } else if (adverEventList && eventView && slideIndex === 0) {
      time = 180000;
    } else {
      time = 3000;
    }

    return time;
  };
  useEffect(() => {
    const timer = setInterval(() => {
      setSlideIndex(
        (prev) =>
          (prev + 1) %
          (eventViewTrueCount + adverStoreList.length + customAddLength)
      );
    }, eventTime());
    return () => clearInterval(timer);
  }, [eventView, slideIndex, eventViewTrueCount, adverStoreList.length]);

  const EventSection = () => {
    return (
      <div
        onClick={() => {
          if (adverEventList) {
            openEvent(adverEventList);
          }
        }}
        className="imageBox"
      >
        <img
          className="adImg"
          src={`${process.env.PUBLIC_URL}/knockknock/img/eventBanner.png`}
          alt="이벤트 banner"
        />
      </div>
    );
  };
  const openEvent = (eventData: EventType) => {
    closeModal();
    setRecoil(eventState, {
      ...eventData,
      visible: true,
      coupon: null,
    });
  };
  const StoreSection = (props: {
    adverStoreList: AdvertisementType[];
    navigateAdStore: any;
    adverClick: any;
    handleGoRouletteEvent: any;
    lang: number;
  }) => {
    return (
      <>
        {adverStoreList.map((data, index) => (
          <div className="adverStoreWrap" key={index}>
            <div className="storeName">
              <h2>{data.store_name}</h2>
            </div>
            <div
              key={index}
              onClick={() => {
                navigateAdStore(data.store_id);
                adverClick(data.store_id, data.store_name);
              }}
            >
              {data.mime_type.includes("image") && (
                <div className="imageBox">
                  <img className="adImg" src={data.url_path} alt="광고이미지" />
                </div>
              )}
              {data.mime_type.includes("video") && (
                <div className="imageBox">
                  <video
                    className="adVideo"
                    id={`adVideo${index}`}
                    autoPlay
                    preload="auto"
                    muted
                    loop
                  >
                    <source src={data.full_path} type="video/mp4" />
                  </video>
                </div>
              )}
            </div>
            <div
              className="movement store"
              onClick={() => {
                navigateAdStore(data.store_id);
                adverClick(data.store_id, data.store_name);
              }}
            >
              <h3>{langText.storeSelector_button_menu[lang]}</h3>
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_right_black.svg`}
                alt="storeMovement"
              />
            </div>
            {/* {props.isFloatingEvent && (
              <div className="movement event" onClick={handleGoRouletteEvent}>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_event.svg`}
                  alt="evnetIcon"
                  style={{
                    width: "22px",
                    height: "22px",
                  }}
                />
                <div className="eventText">
                  <h4>100% {langText.prize[lang]}</h4>
                  <h3>{langText.roulette_event[lang]}</h3>
                </div>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_right_pink.svg`}
                  alt="evnetMovement"
                />
              </div>
            )} */}
          </div>
        ))}
      </>
    );
  };

  return (
    <Style>
      <div className="eventPageWrap">
        <button className="closeButton" onClick={closeModal}>
          <p>{langText.close[lang]}</p>
          <img
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
            alt="closeButton"
          />
        </button>

        <div className="adverBackground">
          <div className="slideBtn left" onClick={() => slideHandler(-1)}>
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_event_arrow_left.svg`}
              alt="prevEventButton"
              style={{ width: "40px", height: "40px" }}
            />
          </div>
          {(adverEventList ||
            adverStoreList.length > 0 ||
            customAddLength > 0) && (
            <div
              className="imgContainer"
              style={{ transform: `translateX(-${slideIndex * 100}%)` }}
              ref={sliderRef}
            >
              {adverEventList && <EventSection />}
              {/* 룰렛 이벤트 */}
              {/* {eventView &&
                adverEventList.map((data, index) => (
                  <div
                    key={index}
                    className="imageBox"
                    style={{ width: "100%", height: "65vh" }}
                  >
                    <EventPage
                      event_id={data.event_id}
                      user_id={auth.user_id}
                      user_token_id={auth.user_token_id}
                      resetPage={resetPage}
                      setEventView={setEventView}
                      setEventViewTrueCount={setEventViewTrueCount}
                    />
                  </div>
                ))} */}

              {/* 매장 커스텀 광고 */}
              {customUserIdList.includes(auth.user_id) && (
                <CustomSection
                  auth={auth}
                  navigateAdStore={navigateAdStore}
                  adverClick={adverClick}
                />
              )}
              {/* 매장광고 */}
              <StoreSection
                adverStoreList={adverStoreList}
                navigateAdStore={navigateAdStore}
                adverClick={adverClick}
                handleGoRouletteEvent={handleGoRouletteEvent}
                lang={lang}
              />
            </div>
          )}
          {/* {adverStoreList.length === 0 &&
            customAddLength === 0 &&
            !eventView &&
            adverEventList && (
              <div
                className="imageBox"
                style={{ width: "100%", height: "65vh" }}
              >
                <EventSection />
              </div>
            )} */}
          <div className="slideBtn right" onClick={() => slideHandler(1)}>
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_event_arrow_right.svg`}
              alt="nextEventButton"
              style={{ width: "40px", height: "40px" }}
            />
          </div>
        </div>
      </div>
    </Style>
  );
};
export default EventContent;

const Style = styled.div`
  .adverBackground {
    width: 100%;
    max-height: 65dvh;
    overflow: hidden;
    position: relative;
    background: #000;
  }
  .imgContainer {
    display: flex;
    transition: transform 0.5s ease-in-out;
    transform: translateX(-100%);
  }
  .imageBox {
    width: 100vw;
    max-height: 65dvh;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .slideBtn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 99;
  }

  .left {
    left: 3%;
  }

  .right {
    right: 3%;
  }

  /* 버튼 스타일 */
  .prevEventButton,
  .nextEventButton,
  .closeButton {
    position: absolute;
    z-index: 101;
  }
  .prevEventButton {
    left: 3%;
    bottom: 30%;
  }
  .nextEventButton {
    right: 3%;
    bottom: 30%;
  }
  .closeButton {
    display: flex;
    align-items: center;
    justify-content: space-between;
    right: 3%;
    margin-top: 12px;
    padding: 3px 6px 3px 12px;
    gap: 5px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 50px;
    p {
      font-size: 14px;
      font-weight: 400;
      color: #fff;
    }
    img {
      width: 20px;
      height: 20px;
    }
  }
  .eventPageWrap {
    width: 100vw;
    max-height: 65dvh;
  }
  iframe {
    min-height: 65dvh;
    border: none;
  }

  /* adverStoreWrap */
  .adverStoreWrap {
    position: relative;
  }
  .storeName {
    position: absolute;
    top: 21px;
    left: 41px;
    padding: 8px 30px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 5px;

    h2 {
      font-size: 24px;
      font-weight: 400;
    }
  }

  .adVideo,
  .adImg {
    width: 100vw;
    max-height: 65dvh;
    object-fit: cover;
    background: #000;
  }

  .movement {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: space-between;

    background: rgba(255, 255, 255, 0.6);
    border-radius: 50px;
    gap: 12px;

    h3 {
      font-size: 18px;
      font-weight: 400;
      line-height: 30px;
      color: #262626;
    }
  }
  .movement.store {
    right: 3%;
    bottom: 15%;
    padding: 9px 20px;
    min-width: 185px;
    h3 {
      width: 100%;
      text-align: center;
    }
  }
  .movement.event {
    right: 3%;
    bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    text-align: center;
    padding: 4px 16px;
    background: #ffeef7;
    z-index: 101;
  }
  .eventText {
    h3,
    h4 {
      font-family: "yg-jalnan";
      color: #ff1d79;
      font-weight: 400;
    }
    h3 {
      font-size: 18px;
      line-height: 30px;
    }
    h4 {
      padding-top: 5px;
      font-size: 14px;
    }
  }
  .customButtonWrap {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    gap: 4px;
  }
`;
